module.exports = __webpack_public_path__ + "static/media/image_38.e58910d0.png";